<mat-form-field appearance="outline">
  <mat-label>Business entity</mat-label>
  <mat-select disableOptionCentering [formControl]="businessEntity">
    @if (!required()) {
      <mat-option [value]="undefined">-</mat-option>
    }
    @for (model of businessEntities; track model) {
      <mat-option [value]="model.value">
        {{ model.description }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
